import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { CategoryDetail } from "./components/CategoryDetail";
import { CategoriesContainer } from "./components/categories.container";

function CategoryDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.admin.categories.detail);
  const navigate = useNavigate();
  return <CategoryDetail id={id} onBack={() => navigate("..")} />;
}

export function CategoriesRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<CategoriesContainer />} />
        <Route path=":id" element={<CategoryDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
